import { MerchantFieldSets } from "../types";

export function isCashPayProperty(
  key: string | keyof MerchantFieldSets["cashPay"]
): key is keyof MerchantFieldSets["cashPay"] {
  const cashPayKeys: (keyof MerchantFieldSets["cashPay"])[] = [
    "cashPayLogoUrl",
  ];
  return cashPayKeys.includes(key as keyof MerchantFieldSets["cashPay"]);
}

export function isCompanyInformationProperty(
  key: string | keyof MerchantFieldSets["companyInformation"]
): key is keyof MerchantFieldSets["companyInformation"] {
  const companyInformationKeys: (keyof MerchantFieldSets["companyInformation"])[] = [
    "abn",
    "businessCity",
    "businessPostalCode",
    "businessState",
    "businessStreet",
    "businessStreet2",
    "businessType",
    "companyNumber",
    "craBusinessNumber",
    "craRegistryId",
    "ein",
    "legalBusinessName",
    "partnershipAgreement",
    "proofOfInsurance",
    "registeredCountry",
    "registrationNumber",
    "trustDeed",
  ];
  return companyInformationKeys.includes(
    key as keyof MerchantFieldSets["companyInformation"]
  );
}

export function isCustomerSupportProperty(
  key: string | keyof MerchantFieldSets["customerSupport"]
): key is keyof MerchantFieldSets["customerSupport"] {
  const customerSupportKeys: (keyof MerchantFieldSets["customerSupport"])[] = [
    "customerSupportEmail",
    "customerSupportPhone",
    "customerSupportWebsite",
  ];
  return customerSupportKeys.includes(
    key as keyof MerchantFieldSets["customerSupport"]
  );
}

export function isLeadProperty(
  key: string | keyof MerchantFieldSets["lead"]
): key is keyof MerchantFieldSets["lead"] {
  const leadKeys: (keyof MerchantFieldSets["lead"])[] = [
    "acquirer",
    "firstName",
    "industry",
    "lastName",
    "numOfStores",
    "phone",
    "platform",
    "registeredCountry",
    "salesChannel",
    "storeName",
    "subIndustry",
    "totalAnnualSales",
    "website",
  ];
  return leadKeys.includes(key as keyof MerchantFieldSets["lead"]);
}

export function isStoreLocationProperty(
  key: string | keyof MerchantFieldSets["location"]
): key is keyof MerchantFieldSets["location"] {
  const storeLocationKeys: (keyof MerchantFieldSets["location"])[] = [
    "branchNumber",
    "locationCity",
    "locationName",
    "locationPostalCode",
    "locationState",
    "locationStreet",
    "locationStreet2",
  ];
  return storeLocationKeys.includes(key as keyof MerchantFieldSets["location"]);
}

export function isOwnerProperty(
  key: string | keyof MerchantFieldSets["owner"]
): key is keyof MerchantFieldSets["owner"] {
  const ownerKeys: (keyof MerchantFieldSets["owner"])[] = [
    "certifiedGovIdPrimary",
    "certifiedGovIdSecondary",
    "city",
    "dob",
    "firstName",
    "govId",
    "lastName",
    "postalCode",
    "ssn",
    "state",
    "street",
    "street2",
    "verificationMethod",
  ];
  return ownerKeys.includes(key as keyof MerchantFieldSets["owner"]);
}

export function isPrimaryBankField(
  key: string | keyof MerchantFieldSets["primaryBank"]
): key is keyof MerchantFieldSets["primaryBank"] {
  const primaryBankKeys: (keyof MerchantFieldSets["primaryBank"])[] = [
    "account",
    "bankAccountName",
    "bankBranch",
    "bankName",
    "bsb",
    "canadaChequingAccount",
    "canadaRoutingInstitutionIdNumber",
    "canadaRoutingTransitIdNumber",
    "confirmAccount",
    "confirmCanadaChequingAccount",
    "directDebitAgreement",
    "email",
    "routing",
    "signatoryName",
    "signatoryType",
    "sortCode",
  ];
  return primaryBankKeys.includes(
    key as keyof MerchantFieldSets["primaryBank"]
  );
}

export function isSecondaryBankProperty(
  key: string | keyof MerchantFieldSets["secondaryBank"]
): key is keyof MerchantFieldSets["secondaryBank"] {
  const secondaryBankKeys: (keyof MerchantFieldSets["secondaryBank"])[] = [
    "account2",
    "bankAccountName2",
    "bsb2",
    "confirmAccount2",
  ];
  return secondaryBankKeys.includes(
    key as keyof MerchantFieldSets["secondaryBank"]
  );
}

export function isStoreDetailsProperty(
  key: string | keyof MerchantFieldSets["storeDetails"]
): key is keyof MerchantFieldSets["storeDetails"] {
  const storeDetailsKeys: (keyof MerchantFieldSets["storeDetails"])[] = [
    "acquirer",
    "aveTimeToShip",
    "currenciesAvailable",
    "ddsRestricted",
    "industry",
    "interestedInXBT",
    "numOfStores",
    "platform",
    "salesChannel",
    "selfFulfillment",
    "storeName",
    "subIndustry",
    "totalAnnualSales",
    "website",
  ];
  return storeDetailsKeys.includes(
    key as keyof MerchantFieldSets["storeDetails"]
  );
}
